module.exports = __WEBPACK_EXTERNAL_MODULE_293__;


//////////////////
// WEBPACK FOOTER
// external "axios"
// module id = 293
// module chunks = 0